<template>

  <v-container
    fluid
    grid-list-lg
    class="pa-3"
  >

    <v-layout column wrap>

      <v-flex xs12 sm9 md6 lg2 text-xs-left mt-2>
        <h1 class="thin">{{ $t('message.sensors') }}</h1>
      </v-flex>

      <v-flex xs12 sm9 md6 text-xs-left>

        <v-layout row wrap>

          <v-flex xs12 sm6 md4 lg2>
            <v-card class="card-rounded" min-height="184" style="padding: 10px;">
              <v-card-title>
                <v-layout column align-center>
                  <h1 class="headline mb-0">{{ $t('message.volume_meter') }}</h1>
                  <div>
                    ({{$t('message.tank')}} 5000 L)
                  </div>                  
                </v-layout>
              </v-card-title>
              <v-card-text>
                <v-layout column align-center>
                  <div v-if="mvl1">
                    <div v-if="mvl1.volume">
                      <span class="blue--text">{{ $t('message.volume') }}: <span class="headline">{{ mvl1.volume | volume-filter }}</span> L</span>
                    </div>        
                    <div v-if="mvl1.height">
                      <span class="blue--text">{{ $t('message.height') }}: <span class="headline">{{ mvl1.height }}</span> m</span>
                    </div>
                  </div>
                  <div v-else>
                    <app-progress-circular-container></app-progress-circular-container>
                  </div>
                </v-layout>
              </v-card-text>
              <v-card-actions v-if="mvl1">
                <v-layout column align-center>
                  <div v-if="mvl1.updatedAt" class="small-caption grey--text">
                    {{ $t('message.updated_at') }}: {{ mvl1.updatedAt | date($i18n.locale) }}
                  </div>                  
                </v-layout>
              </v-card-actions>                         
            </v-card>                                

          </v-flex>

          <v-flex xs12 sm6 md4 lg2>
            <v-card class="card-rounded" min-height="184" style="padding: 10px;">
              <v-card-title>
                <v-layout column align-center>
                  <h1 class="headline mb-0">{{ $t('message.volume_meter') }}</h1>
                  <div>
                     ({{$t('message.tank')}} 10000 L)
                  </div>
                </v-layout>
              </v-card-title>
              <v-card-text>
                <v-layout column align-center>
                  <div v-if="mvl2">
                    <div v-if="mvl2.volume">
                      <span class="blue--text">{{ $t('message.volume') }}: <span class="headline">{{ mvl2.volume | volume-filter }}</span> L</span>
                    </div>        
                    <div v-if="mvl2.height">
                      <span class="blue--text">{{ $t('message.height') }}: <span class="headline">{{ mvl2.height }}</span> m</span>
                    </div> 
                  </div>
                  <div v-else>
                    <app-progress-circular-container></app-progress-circular-container>
                  </div>
                </v-layout>
              </v-card-text>
              <v-card-actions v-if="mvl2">
                <v-layout column align-center>
                  <div v-if="mvl2.updatedAt" class="small-caption grey--text">
                    {{ $t('message.updated_at') }}: {{ mvl2.updatedAt | date($i18n.locale) }}
                  </div>   
                </v-layout>
              </v-card-actions>                         
            </v-card>                                

          </v-flex>      

        </v-layout>        
            
      </v-flex>
       
    </v-layout>

  </v-container>
  
</template>

<script>

import * as firebase from 'firebase'
import ProgressCircularContainer from '@/components/Base/ProgressCircularContainer'

export default {
  components: {
    'app-progress-circular-container': ProgressCircularContainer
  },
  data () {
    return {
      mvl1: null,
      mvl2: null
    }
  },
  computed: {
    locale: function () {
      return this.$store.getters.language
    }
  },
  mounted () {
    this.getRealTimeData('80:7d:3a:c1:7c:1c', 'mvl1')
    this.getRealTimeData('84:0d:8e:0c:85:54', 'mvl2')
  },
  methods: {
    goTo (route) {
      this.$router.push(route)
    },
    getRealTimeData (mac, mvl) {
      let self = this
      firebase.database().ref('status')
        .child('mvl')
        .child(mac)
        .on('value', function (snap) {
          // TODO It need improvement
          if (mvl === 'mvl1') {
            self.mvl1 = snap.val()
            self.mvl1.volume = self.calcVolume(self.mvl1.length, self.mvl1.radius, self.mvl1.height)
          } else if (mvl === 'mvl2') {
            self.mvl2 = snap.val()
            self.mvl2.volume = self.calcVolume(self.mvl2.length, self.mvl2.radius, self.mvl2.height)
          }
        })
    },
    calcVolume (length, radius, _height) {
      // console.log('here', length, radius, _height)
      try {
        const lengthInMeters = parseInt(length, 10) / 1000
        // console.log('lengthInMeters', lengthInMeters)
        const radiusInMeters = parseInt(radius, 10) / 1000
        const height = parseFloat(_height.replace(',', '.'))
        // console.log('height', height)
        // console.log('radiusInMeters', radiusInMeters)
        const result = (lengthInMeters * (Math.pow(radiusInMeters, 2) * Math.acos(1 - (height / radiusInMeters)) - Math.sqrt(2 * height * radiusInMeters - Math.pow(height, 2)) * (radiusInMeters - height))) * 1000
        // console.log('result', result)
        return result
      } catch (err) {
        console.log(err)
      }
      return 0
    }
  }
}
</script>

<style scoped>

  .thin {
    font-weight: 400;
    font-size: 18px;
    margin-bottom: 20px;
  }

  .m-link {
    cursor: pointer;
  }

  .small-caption {
    margin-top: 12px !important;
    font-size: 10px !important;
  }  

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Main.vue